import { SET_LOAN_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const loanUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_LOAN_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default loanUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/Loan/reducer.js